import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { CaButtonComponent } from '@global-front-components/ui/button';

@Component({
	selector: 'app-pymes-coberturas',
	standalone: true,
	imports: [CommonModule, TranslateModule, CaButtonComponent],
	templateUrl: './pymes-coberturas.component.html',
	styleUrls: ['./pymes-coberturas.component.scss']
})
export class PymesCoberturasComponent {

	@Input() principales: string[] = [
		'Medicina primaria y especialistas',
		'Urgencias',
		'Métodos Terapéuticos',
		'Pruebas diagnósticas',
		'Hospitalización e intervenciones',
		'Urgencias en el extranjero',
		'Segunda opinión médica',
		'Complemento dental con 25 actos gratis',
		'Medicina Digital: Video y Teleconsultas'
	];

	@Input() diferenciales: string[] = [
		'Reproducción asistida ampliada a 45 años',
		'20 sesiones de Psicología, más 20 sesiones adicionales por Trastorno Alimentario',
		'Rehabilitación suelo pélvico ampliado a incontinencia urinaria',
		'Podología ilimitada',
		'Asistencia urgente en el extranjero'
	];

	constructor(private location: Location) { }

	goBack() {
		this.location.back();
	}
}
